import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { SocialNetworkOption } from '../models/sala.model';

export type { SocialNetworkOption } from '../models/sala.model';

export interface PlatformSocialLink {
  id: number | null;
  network: string;
  label: string;
  url: string;
  is_active: boolean;
}

export interface PlatformSocialLinksResponse {
  links: Array<PlatformSocialLink & { id: number; sort_order: number }>;
  catalog: SocialNetworkOption[];
  suggested: string[];
  limit: number;
  msg?: string;
}

@Injectable({ providedIn: 'root' })
export class PlatformSocialLinksService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/platform-settings/social-links`;

  load(): Observable<PlatformSocialLinksResponse> {
    return this.http.get<PlatformSocialLinksResponse>(this.url);
  }

  /** Reemplaza la lista completa; el orden del arreglo define el orden público. */
  save(links: PlatformSocialLink[]): Observable<PlatformSocialLinksResponse> {
    return this.http.put<PlatformSocialLinksResponse>(this.url, { links });
  }
}
